import { createAction, props, union } from '@ngrx/store';
import { PayrollRuleEntry, CreatePayrollRuleEntry, DeletePayrollRuleInput } from 'app/api/payroll.rule.api.service';
import { PayrollRuleQuery } from '../payroll.types';

const source = 'payrollRule';
const actions = 'api';

export const payrollRuleRequested = createAction(
    `[${source}][${actions}] PayrollRule requested`,
    props<{ query: PayrollRuleQuery }>()
);
export const payrollRuleLoaded = createAction(
    `[${source}][${actions}] PayrollRule loaded`,
    props<{ entries: PayrollRuleEntry[] }>()
);
export const payrollRuleCreateRequested = createAction(
    `[${source}][${actions}] PayrollRule create requested`,
    props<{ input: CreatePayrollRuleEntry }>()
);
export const payrollRuleCreated = createAction(
    `[${source}][${actions}] PayrollRule created`,
    props<{ input: PayrollRuleEntry }>()
);
export const payrollRuleRemoveOneRequested = createAction(
    `[${source}][${actions}] PayrollRule remove one requested`,
    props<{ input: DeletePayrollRuleInput }>()
);
export const payrollRuleRemoved = createAction(
    `[${source}][${actions}] PayrollRule entry removed`,
    props<{ input: DeletePayrollRuleInput }>()
);
export const payrollRuleRemoveFailed = createAction(
    `[${source}][${actions}] PayrollRule remove failed`,
    props<{ errorMessage: string }>()
);
export const payrollRuleUpdateOneRequested = createAction(
    `[${source}][${actions}] PayrollRule update one requested`,
    props<{ input: PayrollRuleEntry }>()
);
export const payrollRuleUpdated = createAction(
    `[${source}][${actions}] PayrollRule entry updated`,
    props<{ input: PayrollRuleEntry }>()
);
export const payrollRuleCancelled = createAction(
    `[${source}][${actions}] PayrollRule cancelled`,
    props<{ errorMessage: string }>()
);

export const payrollRuleRemoveAll = createAction(
    `[${source}][${actions}] PayrollRule Remove all`
);

const all = union({
    payrollRuleRequested,
    payrollRuleLoaded,
    payrollRuleCancelled,
    payrollRuleRemoveAll,
    payrollRuleCreateRequested,
    payrollRuleRemoved,
    payrollRuleRemoveOneRequested,
    payrollRuleRemoveFailed,
    payrollRuleUpdated,
    payrollRuleUpdateOneRequested
});

export type payrollRuleActionsUnion = typeof all;
